import { createUseStyles } from "react-jss";
export default createUseStyles(function (theme) {
  return {
    container: {
      fill: theme.palette.grey[12],
      display: 'flex',
      justifyContent: 'center'
    },
    clickable: {
      cursor: 'pointer'
    },
    disabled: {
      fill: theme.palette.grey[8]
    },
    colorDefault: {
      fill: 'white'
    },
    primary: {
      fill: theme.palette.primary.dark
    },
    secondary: {
      fill: theme.palette.secondary.dark
    },
    success: {
      fill: theme.palette.success.regular
    },
    warning: {
      fill: theme.palette.warning.regular
    },
    danger: {
      fill: theme.palette.danger.regular
    },
    primary_contrast: {
      fill: theme.palette.primary.text
    },
    secondary_contrast: {
      fill: theme.palette.secondary.text
    },
    success_contrast: {
      fill: theme.palette.success.text
    },
    warning_contrast: {
      fill: theme.palette.warning.text
    },
    danger_contrast: {
      fill: theme.palette.danger.text
    }
  };
});